import type { IPublicationV2 } from '../../../../repositories/billing-tariffs/entities/PublishTerms/PublicationV2';
import { defaultState, IPaidPublicationState } from '../../../../reducers/v2';
import { mapTariffId } from './mapTariffId';
import { defaultTo } from 'ramda';

export function mapPublication(paidPublication: IPublicationV2): IPaidPublicationState {
  return {
    ...paidPublication,
    tariffIdentificator: paidPublication.tariffIdentificator
      ? mapTariffId(paidPublication.tariffIdentificator)
      : undefined,
    autoProlong: paidPublication.isAutoProlongEnabled,
    days: paidPublication.days || 1,
    highDemandCoefficient: paidPublication.highDemandCoefficient || 1,
    restriction: defaultTo(defaultState.restriction, paidPublication.restriction),
    type: paidPublication.type,
  };
}
